import React from 'react';

export default function useDeleteBox() {
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState("");
    const [deleteId, setDeleteId] = React.useState(null);

    const openDelete = (msg, bool, id) => {
        setMessage(msg)
        setOpen(bool);
        setDeleteId(id)
    }

    return { open, message, openDelete, deleteId }
}